"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _router = _interopRequireDefault(require("./router"));
var _store = _interopRequireDefault(require("./store"));
var _elementUi = require("element-ui");
var _nprogress = _interopRequireDefault(require("nprogress"));
require("nprogress/nprogress.css");
var _auth = require("@/utils/auth");
var _getPageTitle = _interopRequireDefault(require("@/utils/get-page-title"));
_nprogress.default.configure({
  showSpinner: false
});
var whiteList = ['/login', '/auth-redirect'];
function getLoginLocation(to) {
  var query = {
    redirect: to.fullPath
  };
  if (to.query && to.query.account) {
    query.account = to.query.account;
  }
  return {
    path: '/login',
    query: query
  };
}
_router.default.beforeEach(/*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(to, from, next) {
    var hasToken, hasRoles, _yield$store$dispatch, asyncRoutes, roles, accessRoutes, _t;
    return (0, _regenerator2.default)().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _nprogress.default.start();
          document.title = (0, _getPageTitle.default)(to.meta.title);
          hasToken = (0, _auth.getToken)();
          if (!hasToken) {
            _context.n = 12;
            break;
          }
          if (!(_store.default.getters.isLock && to.path !== '/lock')) {
            _context.n = 1;
            break;
          }
          next({
            path: '/lock'
          });
          _nprogress.default.done();
          _context.n = 11;
          break;
        case 1:
          if (!(to.path === '/login')) {
            _context.n = 2;
            break;
          }
          if (_store.default.getters.roles.includes('channel')) {
            next({
              path: '/channel'
            });
          } else {
            next({
              path: '/'
            });
          }
          _nprogress.default.done();
          _context.n = 11;
          break;
        case 2:
          if (!(!_store.default.getters.brandList || !_store.default.getters.brandList.length)) {
            _context.n = 3;
            break;
          }
          _context.n = 3;
          return _store.default.dispatch('system/getBrandList');
        case 3:
          if (!(!_store.default.getters.brandListAll || !_store.default.getters.brandListAll.length)) {
            _context.n = 4;
            break;
          }
          _context.n = 4;
          return _store.default.dispatch('system/getBrandListAll');
        case 4:
          if (!(!_store.default.getters.channelList || !_store.default.getters.channelList.length)) {
            _context.n = 5;
            break;
          }
          _context.n = 5;
          return _store.default.dispatch('system/getPayChannelList');
        case 5:
          hasRoles = _store.default.getters.roles && _store.default.getters.roles.length > 0;
          if (!hasRoles) {
            _context.n = 6;
            break;
          }
          next();
          _context.n = 11;
          break;
        case 6:
          _context.p = 6;
          _context.n = 7;
          return _store.default.dispatch('user/getInfo');
        case 7:
          _yield$store$dispatch = _context.v;
          asyncRoutes = _yield$store$dispatch.asyncRoutes;
          roles = _yield$store$dispatch.roles;
          _context.n = 8;
          return _store.default.dispatch('permission/generateRoutes', {
            routerList: asyncRoutes,
            roles: roles
          });
        case 8:
          accessRoutes = _context.v;
          _router.default.addRoutes(accessRoutes);
          if (roles.includes('channel')) {
            next({
              path: '/channel'
            });
          } else if (roles.includes('intermodalPartner')) {
            next({
              path: '/statistics/aliyunLog'
            });
          } else {
            next((0, _objectSpread2.default)((0, _objectSpread2.default)({}, to), {}, {
              replace: true
            }));
          }
          _context.n = 11;
          break;
        case 9:
          _context.p = 9;
          _t = _context.v;
          _context.n = 10;
          return _store.default.dispatch('user/resetToken');
        case 10:
          _elementUi.Message.error(_t || 'Has Error');
          next(getLoginLocation(to));
          _nprogress.default.done();
        case 11:
          _context.n = 13;
          break;
        case 12:
          if (whiteList.indexOf(to.path) !== -1) {
            next();
          } else {
            next(getLoginLocation(to));
            _nprogress.default.done();
          }
        case 13:
          return _context.a(2);
      }
    }, _callee, null, [[6, 9]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
_router.default.afterEach(function () {
  _nprogress.default.done();
});